// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WomanHero_heroWoman__ZVyqU {
    position: relative;
    font-family: 'Aktiv Grotesk';
    font-size: 24px;
}
.WomanHero_heroGradient__ykJQW {
    background: linear-gradient(to right, rgb(16, 207, 201, 1), rgb(106, 191, 75, 1));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: 'Cocon Bold';
    font-size: 85px;
}
.WomanHero_hero__r3lDZ {
    width: 100%;
    max-height: 1080px;
    overflow: hidden;
}
.WomanHero_heroImage__aXSFE {
    position: block;
    float: right;
}

.WomanHero_heroImage__aXSFE img {
    vertical-align: bottom;
    z-index: -1;
}
.WomanHero_heroText__ELM4N {
    position: absolute;
    float: left;
    padding-left: 8%;
    width: 92%;
    margin-top: 320px;
}
.WomanHero_heroFinally__IsUjo {

}
.WomanHero_heroSafe__cFhcK {
    font-size: 48px;
    font-weight: 700;
}
.WomanHero_heroWeight__rHj8p {
    font-size: 107px;
    font-weight: 700;
}

.WomanHero_heroButton__AH7Qa {
    margin-top: 15px;
    width: 300px;
    background-color: rgb(106, 191, 75, 1);
    color: white;
    font-family: 'Cocon Bold';
    font-size: 36px;
    padding: 10px 35px;
    border-radius: 999px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    vertical-align: middle;
}

.WomanHero_heroButton__AH7Qa:hover {
    transition: 0.5s;
    box-shadow: 10px 10px 0 #FBC638;
}
.WomanHero_bullets__cdSqf {
    margin-top: 70px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 29px;
    font-weight: 700;
}
.WomanHero_bullet__xF\\+\\+P {
    font-size: 40px;
    padding-left: 30px;
    vertical-align: middle;
}


.WomanHero_heroAsterisk__VtuWy {
    margin-top: 50px;
}

.WomanHero_heroAsterisk__VtuWy a {
    color: black;
    text-decoration: none;
    font-weight: 700;
}
.WomanHero_heroSubtext__VtC2T {
    margin-top: 75px;
    font-size: 12px;
    max-width: 50%
}
.WomanHero_buttonArrow__ZutRO {
    margin-left: 10px;
    width: 36px;
}

@media (hover: hover) and (pointer: fine) {
    .WomanHero_heroAsterisk__VtuWy a:hover {
        color: #21ceca;;
    }
}

/* CSS for active (click) effect on mobile */
@media (hover: none) and (pointer: coarse) {
    .WomanHero_heroAsterisk__VtuWy a:active {
        color: #21ceca;;
    }
}


@media screen and (max-width: 1800px) {
    .WomanHero_heroImage__aXSFE {
        opacity: 0.33;
    }
    .WomanHero_heroImage__aXSFE img {
        height: 960px
    }
    .WomanHero_heroText__ELM4N {
        margin-top: 260px;
    }
    .WomanHero_bullets__cdSqf {
        margin-top: 50px;
    }
    .WomanHero_heroSubtext__VtC2T {
        margin-top: 60px;
        max-width: 90%;
    }
}
@media screen and (max-width: 1500px) {
    .WomanHero_heroImage__aXSFE {
        min-height: 0;
        margin-right: 0%;
    }
    .WomanHero_heroImage__aXSFE img {
        height: 970px
    }
    .WomanHero_heroText__ELM4N {
        margin-top: 210px;
    }
    .WomanHero_heroWeight__rHj8p {
        font-size: 85px;
    }
    .WomanHero_bullets__cdSqf {
        margin-top: 70px;
        font-size: 29px;
        font-weight: 700;
    }
    .WomanHero_heroSubtext__VtC2T {
        margin-top: 100px;
        max-width: 90%;
    }
}
@media screen and (max-width: 1170px) {
    .WomanHero_heroImage__aXSFE {
        margin-right: -30%;
    }
}
@media screen and (max-width: 775px) {
    .WomanHero_heroText__ELM4N {
        margin-top: 140px;
    }
}
@media screen and (max-width: 720px) {
    .WomanHero_heroImage__aXSFE {
        margin-right: -50%;
    }

    .WomanHero_heroImage__aXSFE img {
        height: 955px
    }
    .WomanHero_bullets__cdSqf {
        margin-top: 55px;
    }
    .WomanHero_heroSubtext__VtC2T {
        max-width: 98%;
    }
}
@media screen and (max-width: 684px) {
    .WomanHero_heroImage__aXSFE img {
        height: 914px
    }
    .WomanHero_heroSubtext__VtC2T {
        margin-top: 32px;
    }
}
@media screen and (max-width: 625px) {
    .WomanHero_heroImage__aXSFE {
        margin-right: -45%;
        opacity: 20%;
    }
    .WomanHero_heroImage__aXSFE img {
        height: 812px
    }
    .WomanHero_heroSafe__cFhcK {
        font-size: 36px;
    }
    .WomanHero_heroWeight__rHj8p {
        font-size: 65px;
    }
    .WomanHero_bullets__cdSqf {
        margin-top: 35px;
        font-size: 24px;
    }
    .WomanHero_heroAsterisk__VtuWy {
        margin-top: 20px;
    }
}
@media screen and (max-width: 506px) {
    .WomanHero_heroImage__aXSFE {
        margin-right: -70%;
    }
    .WomanHero_heroImage__aXSFE img {
        height: 767px
    }
    .WomanHero_heroSafe__cFhcK {
        font-size: 24px;
    }
    .WomanHero_heroWeight__rHj8p {
        font-size: 45px;
    }
    .WomanHero_bullets__cdSqf {
        margin-top: 25px;
        font-size: 21px;
    }
}
@media screen and (max-width: 469px) {
    .WomanHero_heroImage__aXSFE img {
        height: 660px
    }
    .WomanHero_heroGradient__ykJQW {
        font-size: 65px;
    }
    .WomanHero_heroText__ELM4N {
        padding-left: 4%;
        width: 96%;
    }
    .WomanHero_heroButton__AH7Qa {
        width: 260px;
        padding: 8px 15px;
        font-size: 30px;
    }
    .WomanHero_bullet__xF\\+\\+P {
        font-size: 20px;
    }

    .WomanHero_heroAsterisk__VtuWy {
        font-size: 20px;
    }
}
@media screen and (max-width: 424px) {
    .WomanHero_heroImage__aXSFE img {
        height: 674px
    }
}
@media screen and (max-width: 350px) {
    .WomanHero_heroImage__aXSFE img {
        height: 657px
    }
    .WomanHero_heroGradient__ykJQW {
        font-size: 65px;
    }
    .WomanHero_heroButton__AH7Qa {
        width: 210px;
        padding: 10px 35px;
        font-size: 25px;
    }
    .WomanHero_buttonArrow__ZutRO {
        width: 25px;
    }
}
@media screen and (max-width: 320px) {
    .WomanHero_heroImage__aXSFE img {
        height: 665px
    }
}
@media screen and (max-width: 300px) {
    .WomanHero_heroImage__aXSFE img {
        height: 595px
    }
    .WomanHero_heroGradient__ykJQW {
        font-size: 45px;
    }
    .WomanHero_heroText__ELM4N {
        margin-top: 100px;
    }
    .WomanHero_heroSafe__cFhcK {
        font-size: 18px;
    }
    .WomanHero_heroWeight__rHj8p {
        font-size: 32px;
    }
    .WomanHero_heroButton__AH7Qa {
        width: 180px;
        padding: 8px 15px;
        font-size: 20px;
    }
    .WomanHero_bullets__cdSqf {
        margin-top: 15px;
        font-size: 18px;
    }
    .WomanHero_heroAsterisk__VtuWy {
        font-size: 16px;
    }
}
@media screen and (max-width: 273px) {
    .WomanHero_bullets__cdSqf {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Landing/WomanHero.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,iFAAiF;IACjF,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,iBAAiB;AACrB;AACA;;AAEA;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,cAAc;IAClB;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;IACA;QACI;IACJ;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;AACA;IACI;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI;IACJ;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI;IACJ;IACA;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI;IACJ;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;AACA;IACI;QACI;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".heroWoman {\n    position: relative;\n    font-family: 'Aktiv Grotesk';\n    font-size: 24px;\n}\n.heroGradient {\n    background: linear-gradient(to right, rgb(16, 207, 201, 1), rgb(106, 191, 75, 1));\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-family: 'Cocon Bold';\n    font-size: 85px;\n}\n.hero {\n    width: 100%;\n    max-height: 1080px;\n    overflow: hidden;\n}\n.heroImage {\n    position: block;\n    float: right;\n}\n\n.heroImage img {\n    vertical-align: bottom;\n    z-index: -1;\n}\n.heroText {\n    position: absolute;\n    float: left;\n    padding-left: 8%;\n    width: 92%;\n    margin-top: 320px;\n}\n.heroFinally {\n\n}\n.heroSafe {\n    font-size: 48px;\n    font-weight: 700;\n}\n.heroWeight {\n    font-size: 107px;\n    font-weight: 700;\n}\n\n.heroButton {\n    margin-top: 15px;\n    width: 300px;\n    background-color: rgb(106, 191, 75, 1);\n    color: white;\n    font-family: 'Cocon Bold';\n    font-size: 36px;\n    padding: 10px 35px;\n    border-radius: 999px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    cursor: pointer;\n    vertical-align: middle;\n}\n\n.heroButton:hover {\n    transition: 0.5s;\n    box-shadow: 10px 10px 0 #FBC638;\n}\n.bullets {\n    margin-top: 70px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    font-size: 29px;\n    font-weight: 700;\n}\n.bullet {\n    font-size: 40px;\n    padding-left: 30px;\n    vertical-align: middle;\n}\n\n\n.heroAsterisk {\n    margin-top: 50px;\n}\n\n.heroAsterisk a {\n    color: black;\n    text-decoration: none;\n    font-weight: 700;\n}\n.heroSubtext {\n    margin-top: 75px;\n    font-size: 12px;\n    max-width: 50%\n}\n.buttonArrow {\n    margin-left: 10px;\n    width: 36px;\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .heroAsterisk a:hover {\n        color: #21ceca;;\n    }\n}\n\n/* CSS for active (click) effect on mobile */\n@media (hover: none) and (pointer: coarse) {\n    .heroAsterisk a:active {\n        color: #21ceca;;\n    }\n}\n\n\n@media screen and (max-width: 1800px) {\n    .heroImage {\n        opacity: 0.33;\n    }\n    .heroImage img {\n        height: 960px\n    }\n    .heroText {\n        margin-top: 260px;\n    }\n    .bullets {\n        margin-top: 50px;\n    }\n    .heroSubtext {\n        margin-top: 60px;\n        max-width: 90%;\n    }\n}\n@media screen and (max-width: 1500px) {\n    .heroImage {\n        min-height: 0;\n        margin-right: 0%;\n    }\n    .heroImage img {\n        height: 970px\n    }\n    .heroText {\n        margin-top: 210px;\n    }\n    .heroWeight {\n        font-size: 85px;\n    }\n    .bullets {\n        margin-top: 70px;\n        font-size: 29px;\n        font-weight: 700;\n    }\n    .heroSubtext {\n        margin-top: 100px;\n        max-width: 90%;\n    }\n}\n@media screen and (max-width: 1170px) {\n    .heroImage {\n        margin-right: -30%;\n    }\n}\n@media screen and (max-width: 775px) {\n    .heroText {\n        margin-top: 140px;\n    }\n}\n@media screen and (max-width: 720px) {\n    .heroImage {\n        margin-right: -50%;\n    }\n\n    .heroImage img {\n        height: 955px\n    }\n    .bullets {\n        margin-top: 55px;\n    }\n    .heroSubtext {\n        max-width: 98%;\n    }\n}\n@media screen and (max-width: 684px) {\n    .heroImage img {\n        height: 914px\n    }\n    .heroSubtext {\n        margin-top: 32px;\n    }\n}\n@media screen and (max-width: 625px) {\n    .heroImage {\n        margin-right: -45%;\n        opacity: 20%;\n    }\n    .heroImage img {\n        height: 812px\n    }\n    .heroSafe {\n        font-size: 36px;\n    }\n    .heroWeight {\n        font-size: 65px;\n    }\n    .bullets {\n        margin-top: 35px;\n        font-size: 24px;\n    }\n    .heroAsterisk {\n        margin-top: 20px;\n    }\n}\n@media screen and (max-width: 506px) {\n    .heroImage {\n        margin-right: -70%;\n    }\n    .heroImage img {\n        height: 767px\n    }\n    .heroSafe {\n        font-size: 24px;\n    }\n    .heroWeight {\n        font-size: 45px;\n    }\n    .bullets {\n        margin-top: 25px;\n        font-size: 21px;\n    }\n}\n@media screen and (max-width: 469px) {\n    .heroImage img {\n        height: 660px\n    }\n    .heroGradient {\n        font-size: 65px;\n    }\n    .heroText {\n        padding-left: 4%;\n        width: 96%;\n    }\n    .heroButton {\n        width: 260px;\n        padding: 8px 15px;\n        font-size: 30px;\n    }\n    .bullet {\n        font-size: 20px;\n    }\n\n    .heroAsterisk {\n        font-size: 20px;\n    }\n}\n@media screen and (max-width: 424px) {\n    .heroImage img {\n        height: 674px\n    }\n}\n@media screen and (max-width: 350px) {\n    .heroImage img {\n        height: 657px\n    }\n    .heroGradient {\n        font-size: 65px;\n    }\n    .heroButton {\n        width: 210px;\n        padding: 10px 35px;\n        font-size: 25px;\n    }\n    .buttonArrow {\n        width: 25px;\n    }\n}\n@media screen and (max-width: 320px) {\n    .heroImage img {\n        height: 665px\n    }\n}\n@media screen and (max-width: 300px) {\n    .heroImage img {\n        height: 595px\n    }\n    .heroGradient {\n        font-size: 45px;\n    }\n    .heroText {\n        margin-top: 100px;\n    }\n    .heroSafe {\n        font-size: 18px;\n    }\n    .heroWeight {\n        font-size: 32px;\n    }\n    .heroButton {\n        width: 180px;\n        padding: 8px 15px;\n        font-size: 20px;\n    }\n    .bullets {\n        margin-top: 15px;\n        font-size: 18px;\n    }\n    .heroAsterisk {\n        font-size: 16px;\n    }\n}\n@media screen and (max-width: 273px) {\n    .bullets {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroWoman": `WomanHero_heroWoman__ZVyqU`,
	"heroGradient": `WomanHero_heroGradient__ykJQW`,
	"hero": `WomanHero_hero__r3lDZ`,
	"heroImage": `WomanHero_heroImage__aXSFE`,
	"heroText": `WomanHero_heroText__ELM4N`,
	"heroFinally": `WomanHero_heroFinally__IsUjo`,
	"heroSafe": `WomanHero_heroSafe__cFhcK`,
	"heroWeight": `WomanHero_heroWeight__rHj8p`,
	"heroButton": `WomanHero_heroButton__AH7Qa`,
	"bullets": `WomanHero_bullets__cdSqf`,
	"bullet": `WomanHero_bullet__xF++P`,
	"heroAsterisk": `WomanHero_heroAsterisk__VtuWy`,
	"heroSubtext": `WomanHero_heroSubtext__VtC2T`,
	"buttonArrow": `WomanHero_buttonArrow__ZutRO`
};
export default ___CSS_LOADER_EXPORT___;
